module.exports = "<div class=\"spinner-container\" *ngIf=\"showSpinner\">\r\n  <div class=\"sk-folding-cube\">\r\n    <div class=\"sk-cube1 sk-cube\"></div>\r\n    <div class=\"sk-cube2 sk-cube\"></div>\r\n    <div class=\"sk-cube4 sk-cube\"></div>\r\n    <div class=\"sk-cube3 sk-cube\"></div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/shared/spinner/spinner.component.html
// module id = ../../../../../src/app/shared/spinner/spinner.component.html
// module chunks = main